let itm = {
  // bcg: require('../bcg_unit.png'),
  bcg2: require('./u5.png'),
  name: 'The rainy day',
  items: [],
};

export default itm;
